import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_PATIENT_DETAILS_REQUEST,
  GET_DASHBOARD_PATIENT_DETAILS_SUCCESS,
  GET_DASHBOARD_PATIENT_DETAILS_FAILURE,
  GET_DASHBOARD_PATIENT_DETAILS_LOADER,
  GET_DASHBOARD_PATIENT_DETAILS_RESET,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isPatientInfo: false,
  loading: false,
};

export const dashboardPatientInfo = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_PATIENT_DETAILS_SUCCESS: {
      return {
        ...state,
        isPatientInfo: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DASHBOARD_PATIENT_DETAILS_FAILURE:
      return {
        ...state,
        isPatientInfo: false,
        response: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_PATIENT_DETAILS_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
